<div class="card flex justify-content-center">
  <p-paginator (onPageChange)="onPageChange($event)" [first]="first" [rows]="pageSize" [totalRecords]="totalItems"
    [rowsPerPageOptions]="pageSizeOptions" [showCurrentPageReport]="true"
    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
    styleClass="border-none bg-transparent" [showFirstLastIcon]="showFirstLastButtons">
  </p-paginator>
</div>